// extracted by css-extract-rspack-plugin
export default {"EligibleOffersPageFooter-footer":"sputnik__EligibleOffersPageFooter-footer__qbiGL","eligibleOffersPageFooterFooter":"sputnik__EligibleOffersPageFooter-footer__qbiGL"};